/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { StorageGatewayStatus } from '../models/StorageGatewayStatus';

export class StorageGatewayDetails {
  /**
  * Identifier of the VPC endpoint service associated with the storage gateway.
  */
  'vpcEndpointServiceName': string;
  'status'?: StorageGatewayStatus;
  /**
  * The user-imported ACM certificate currently applied to the gateway, if any
  */
  'importedCertificate'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vpcEndpointServiceName",
      "baseName": "vpcEndpointServiceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "StorageGatewayStatus",
      "format": ""
    },
    {
      "name": "importedCertificate",
      "baseName": "importedCertificate",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return StorageGatewayDetails.attributeTypeMap;
  }

  public constructor() {
  }
}



